import React, { useEffect, useState, useMemo } from "react";
import styles from "../../../BorrowerDetails.module.css";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import { url } from "../../../../../../App";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import Cookies from "js-cookie";
import { useBorrowerContext } from "../../../store/borrower-details";
import SingleDocModal from "../SingleDocModal";
import PDFViewer from "../../PDFViewer/PDFViewer";
import { FaClipboard, FaClipboardCheck } from "react-icons/fa";
import MultiDocsModal from "../MultiDocsModal";
import { PDFDocument } from "pdf-lib";
import { AiOutlineEye } from "react-icons/ai";
import { UploadFileOutlined } from "@mui/icons-material";
import { pdfjs, Document, Page } from "react-pdf";
import pdfStyles from "../../PDFViewer/PDFViewer.module.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useMediaQuery } from "react-responsive";
import Modal from '@mui/material/Modal';

const EsignModal = ({
  loanDocsExist,
  closeModal,
  openLoader,
  closeLoader,
  permissions,
  isDisbursed,
}) => {
  const Navigate = useNavigate();
  const TOKEN = Cookies.get("Token");
  const EMAIL = Cookies.get("Email");
  const UNIQUE_NO = localStorage.getItem("uniqueID");
  const { loanid } = useParams();
  const { borrowerData, updateBorrowerData } = useBorrowerContext();
  const { borrower, coapplicant } = borrowerData;
  const CoapplicantsArray = [...coapplicant.map((coapplicant) => coapplicant)];
  const fetchedLoanDetails = borrowerData.loan;
  console.log(fetchedLoanDetails, "fetchedLoanDetails");
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanid);

  useEffect(() => {
    if (foundLoan) {
      setLoanDetails(foundLoan);
    }
  }, [foundLoan]);
  const [loanDetails, setLoanDetails] = useState(foundLoan || null);
  const [esignVal, setEsignVal] = useState("");
  const [loanAgreementLoader, setLoanAgreementLoader] = useState(false);
  const [permission, setPermission] = useState({});
  const [applicantType, setApplicantType] = useState({});
  const [esignModal, setEsignModal] = useState(false);
  const [coapplicantEsign, setCoapplicantEsign] = useState(false);
  const [pdfModal, setPdfModal] = useState({
    open: false,
    data: `data:application/pdf;base64,${url}`,
  });
  const [docModal, setDocModal] = useState(false);
  const [docs, setDocs] = useState([]);
  const [name, setName] = useState("");
  const [openEsignOptionModal, setOpenEsignOptionModal] = useState(false);
  const [openManualModal, setOpenManualModal] = useState(false);
  const [stampPaper, setStampPaper] = useState(null);
  const [revenueStamp, setRevenueStamp] = useState(null);
  const [isMerged, setIsMerged] = useState(false);
  const [mergedBase64, setMergedBase64] = useState("");
  const [openPreviewModal, setOpenPreviewModal] = useState(false);

  console.log(applicantType);

  const [singleDocModal, setSingleDocModal] = useState({
    open: false,
    doc: "",
    docType: "",
  });
  const [applicationForms, setApplicationForms] = useState(
    loanDetails?.loan_agreement || []
  );
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const handlePassword = (callback, reason) => {
    const callbackProxy = (password) => {
      if (password === null) {
        const promptWindow = window.open("", "_self");
        promptWindow.close();
        closeModal();
        return;
      }
      callback(password);
    };

    const password = prompt("Enter Password");
    callbackProxy(password);
    return;
  };

  const [numPages, setNumPages] = useState(null);
  const [width, setWidth] = useState(700);
  const isPhone = useMediaQuery({ query: "(max-width: 550px)" });
  const [stamp_data, setstamp_data] = useState(null)
  const [stampBase64, setStampBase64] = useState("");
  const [previewType, setPreviewType] = useState(null);
  const [stampInfo, setstampInfo] = useState(null);
  const [openCpanelModal, setopenCpanelModal] = useState(false);
  const [manualPDFmodal, setmanualPDFmodal] = useState(false);
  const [StampDocLoading,setStampDocLoading]=useState(false);

  useEffect(() => {
    if (isPhone) {
      setWidth(400);
    }
  }, [isPhone]);

  const pdfFile = useMemo(() => {
    const base64 =
      previewType === "stamp"
        ? stampBase64
        : previewType === "merged"
          ? mergedBase64
          : null;

    // console.log("previewType-> ", previewType)
    // console.log("base64-> ", base64)

    if (!base64) return null;

    const cleanBase64 = base64.replace(
      /^data:application\/pdf;base64,/,
      ""
    );

    const binaryString = window.atob(cleanBase64);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return { data: bytes };
    // eslint-disable-next-line
  }, [stampBase64, mergedBase64, previewType, manualPDFmodal, isMerged,handlePreviewMergedDoc]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleAuditUpload = (documentId) => {
    let text = `Are you sure you want to upload audit trail?`;
    if (!window.confirm(text)) {
      return;
    }
    document.getElementById(`audit-upload-${documentId}`)?.click();
  };

  const handleLoanAgreementUpload = (documentId) => {
    let text = `Are you sure you want to upload loan agreement?`;
    if (!window.confirm(text)) {
      return;
    }
    document.getElementById(`agreement-upload-${documentId}`)?.click();
  };

  const handleEsignModal = () => {
    setEsignModal(true);
  };

  const handleEsignClose = () => {
    setEsignModal(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleCoapplicantEsign = () => {
    setCoapplicantEsign(!coapplicantEsign);
  };
  const [checked, setChecked] = React.useState(false);

  const [copied, setCopied] = useState(false);

  const handleCopy = async (link) => {
    if (!link) {
      toast.error("No link available to copy.");
      return;
    }

    try {
      await navigator.clipboard.writeText(link);
      setCopied(link);
      toast.success("Link copied successfully!");

      setTimeout(() => {
        setCopied(null);
      }, 2000);
    } catch (err) {
      toast.error("Failed to copy link.");
    }
  };

  const applicantChangeHandler = (e, applicant) => {
    const { value } = e.target;
    setApplicantType((prevValues) => ({
      ...prevValues,
      [applicant]: value,
    }));
  };

  // eslint-disable-next-line
  const handleStampPaperChange = (e) => {
    setStampPaper(e);
    setIsMerged(false);
    setMergedBase64("");
  };

  const handleRevenueStampChange = (e) => {
    setRevenueStamp(e);
    setIsMerged(false);
    setMergedBase64("");
  };

  const viewDocHandler = async (docName, id) => {
    const { loan_id } = loanDetails;

    const selectedDocs = loanDetails?.[docName]?.filter((doc) => doc.id === id);
    setName(docName === "loan_agreement" ? "Loan Agreement" : "Audit Trail");

    if (!selectedDocs || selectedDocs.length === 0) {
      toast.error("No Document Found. Please upload");
      closeLoader();
      return;
    }

    if (selectedDocs === undefined) {
      toast.error("Document not found");
      return;
    }

    const viewArr = await Promise.all(
      selectedDocs.map(async (data, index) => {
        const req = {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          borrower_uniqueno: localStorage.getItem("uniqueID"),
          doc_name: data.doc_name,
          doc_type: "pdf",
          loan_id: loan_id,
        };

        const docNameArr = data.doc_name
          .split("(")[0]
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1));
        const docName = `${docNameArr[0]} ${docNameArr[1]}`;
        setName(docName);
        const res = await axios.post(url + "/loan/viewdoc", req);

        const downloadHandler = async () => {
          const downloadRes = await axios.post(url + "/loan/downloaddoc", req);
          if (!downloadRes.data.auth) {
            toast.error(downloadRes.data.message);
            return;
          }
          const downloadLink = document.createElement("a");
          const linkSource = `data:application/pdf;base64,${downloadRes.data.doc_base64}`;
          const fileName = `${req.borrower_uniqueno} Loan${req.loan_id} ${req.doc_name}.pdf`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        };

        const deleteHandelr = async () => {
          const text = `Are you sure you want to delete ${req.doc_name}?`;
          if (!window.confirm(text)) {
            return;
          }
          const deleteReq = {
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
            borrower_uniqueno: localStorage.getItem("uniqueID"),
            loan_id: loan_id,
            doc_arr: {
              location: data.location,
              doc_type: "pdf",
              doc_name: data.doc_name,
            },
          };
          const deleteRes = await axios.post(
            url + "/loan/deletedoc",
            deleteReq
          );
          if (!deleteRes.data.auth) {
            return toast.error(deleteRes.data.message);
          }
          toast.success(deleteRes.data.message);
          window.location.reload();
        };

        return {
          doc: res.data.doc_base64,
          docType: req.doc_type,
          download: downloadHandler,
          delete: deleteHandelr,
        };
      })
    );
    if (viewArr.length === 0) {
      toast.error("No docs found");
      return;
    }
    setDocs(viewArr);
    setDocModal(true);
  };

  const closeDocModal = () => {
    setDocModal(false);
  };

  useEffect(() => {
    try {
      setPermission({
        upload: permissions.add_loan_document,
        view: permissions.view_loan_document,
        download: permissions.download_loan_document,
        delete: permissions.delete_loan_document,
        view_kfs_letter: permissions.view_kfs_letter,
        download_kfs_letter: permissions.download_kfs_letter,
        generate_kfs_letter: permissions.generate_kfs_letter,
        initiate_kfs_letter: permissions.initiate_kfs_letter,
        signed_kfs_letter: permissions.signed_kfs_letter,
        view_application_form_doc: permissions.view_application_form_doc,
        download_application_form_doc:
          permissions.download_application_form_doc,
        generate_application_form_doc:
          permissions.generate_application_form_doc,
        initiate_application_form_doc:
          permissions.initiate_application_form_doc,
        signed_application_form_doc: permissions.signed_application_form_doc,
        view_loan_agreement: permissions.view_loan_agreement,
        download_loan_agreement: permissions.download_loan_agreement,
        delete_loan_agreement: permissions.delete_loan_agreement,
        generate_loan_agreement: permissions.generate_loan_agreement,
        upload_loan_agreement: permissions.upload_loan_agreement,
        initiate_loan_agreement: permissions.initiate_loan_agreement,
        upload_audit_trail: permissions.upload_audit_trail,
        view_audit_trail: permissions.view_audit_trail,
        download_audit_trail: permissions.download_audit_trail,
        delete_audit_trail: permissions.delete_audit_trail,
        fetch_esign: permissions.fetch_esign,
      });
    } catch (err) {
      console.log(err);
    }
  }, [permissions]);

  const getSingleEsignDetails = async () => {
    try {
      openLoader();
      const { loan_id } = loanDetails;

      const request = {
        token: TOKEN,
        email: EMAIL,
        loan_id: loan_id,
        esignReason: "loan_agreement",
      };

      await axios.post(url + "/loan/getesign", request);

      const response = await axios.post(url + "/api/fetch/esign/details", {
        loanId: loan_id,
        token: TOKEN,
        email: EMAIL,
      });

      if (response.data.success) {
        const esignDataList = response.data.data || [];
        setApplicationForms((prevForms) =>
          prevForms.map((loan) => {
            const matchingEsign = esignDataList.find(
              (item) => item.digioid === loan.did
            );
            if (!matchingEsign) return loan;
            return {
              ...loan,
              signing_parties: (loan.signing_parties || []).map((party) => ({
                ...party,
                status:
                  party.name === matchingEsign?.Signer1
                    ? matchingEsign?.Signer1status || party.status
                    : party.name === matchingEsign?.Signer2
                      ? matchingEsign?.Signer2status || party.status
                      : party.name === matchingEsign?.Signer3
                        ? matchingEsign?.Signer3status || party.status
                        : party.status,
              })),
            };
          })
        );
      } else {
        console.error("Failed to fetch e-sign details");
      }

      closeLoader();
    } catch (err) {
      console.error("Error in getSingleEsignDetails:", err.message);
      closeLoader();
    }
  };

  const initiateEsignHandler = () => {
    setOpenEsignOptionModal(true);
  };  
  const loadStampData = async () => {
    try {
      setStampDocLoading(true);
      const stampResponse = await axios.post(url + "/loan/getstamp", {
        token: TOKEN,
        email: EMAIL,
        nbfc_name: foundLoan?.nbfc_name,
      });

      setstamp_data(stampResponse?.data?.data?.lastEntry);
      setStampBase64(stampResponse?.data?.data?.base64);
      setStampDocLoading(false);
    } catch (error) {
      console.error("Error loading stamp data:", error);
      setStampDocLoading(false);
    }
  };
  const getStampInfo = async () => {
    try {
      const stampResponseInfo = await axios.post(url + "/nbfc/GetNBFCStampData", {
        token: TOKEN,
        email: EMAIL,
        lender_name: foundLoan?.nbfc_name,
      });
      console.log("stampResponseInfo-> ", stampResponseInfo)
      setstampInfo(stampResponseInfo?.data?.data?.notused)

    } catch (error) {
      console.error("Error loading stamp data:", error);
    }
  }
  const handleEsignOption = async (type) => {
    if (type === "api") {
      handleEsign("Loan Agreement");
    }
    if (type === "manual") {
      setOpenManualModal(true);
      setStampPaper(null);
      setRevenueStamp(null);
    }
    if (type === "manual_cpanel") {
      loadStampData();
      getStampInfo();
      setopenCpanelModal(true)
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const base64ToUint8Array = (base64) => {
    const cleanedBase64 = base64.includes(",") ? base64.split(",")[1] : base64;

    const binaryString = window.atob(cleanedBase64);

    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes;
  };
  const decodePdfBase64 = (b64) => {
    if (!b64 || typeof b64 !== "string") throw new Error("invalid base64");

    // strip data URI prefix if present
    const cleaned = b64.startsWith("data:") ? b64.split(",")[1] : b64;

    // first pass
    let bytes = base64ToUint8Array(cleaned);

    // If it doesn't start with "%PDF-", try decoding once more
    if (bytes[0] !== 0x25 /* '%' */) {
      const secondPass = new TextDecoder().decode(bytes);
      bytes = base64ToUint8Array(secondPass);
    }

    if (bytes[0] !== 0x25) {
      throw new Error("Not a PDF after decoding");
    }

    return bytes;
  };
  const uploadStampPaperHandler = async () => {
    if (!stampBase64) {
      return toast.error("Please upload stamp paper");
    }

    // const file = stampPaper.target.files[0];
    const revenuFile = revenueStamp?.target?.files?.[0];

    // if (file.type !== "application/pdf") {
    //   return toast.error("Only PDF file is allowed");
    // }

    if (revenuFile && revenuFile.type !== "application/pdf") {
      return toast.error("Only PDF file is allowed");
    }
    openLoader();
    let revenueBase64 = null;
    if (revenuFile) {
      revenueBase64 = await convertToBase64(revenuFile);
    }

    const { loan_id } = loanDetails;
    const latestLoanAgreement = loanDetails?.loan_agreement?.at(-1);
    const req = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      doc_name: latestLoanAgreement.doc_name,
      doc_type: "pdf",
      loan_id: loan_id,
    };

    const res = await axios.post(url + "/loan/viewdoc", req);
    const loanAgreementBase64 = res.data?.doc_base64;
    const stampBytes = decodePdfBase64(stampBase64);
    const agreementBytes = base64ToUint8Array(loanAgreementBase64);

    const stampPdf = await PDFDocument.load(stampBytes);
    const agreementPdf = await PDFDocument.load(agreementBytes);

    let revenuePdf = null;
    if (revenueBase64) {
      const revenueBytes = base64ToUint8Array(revenueBase64);
      revenuePdf = await PDFDocument.load(revenueBytes);
    }

    const mergedPdf = await PDFDocument.create();

    const stampPages = await mergedPdf.copyPages(
      stampPdf,
      stampPdf.getPageIndices()
    );

    stampPages.forEach((page) => {
      mergedPdf.addPage(page);
    });

    const agreementPages = await mergedPdf.copyPages(
      agreementPdf,
      agreementPdf.getPageIndices()
    );

    agreementPages.forEach((page) => {
      mergedPdf.addPage(page);
    });

    if (revenuePdf) {
      const revenuePages = await mergedPdf.copyPages(
        revenuePdf,
        revenuePdf.getPageIndices()
      );

      revenuePages.forEach((page) => {
        mergedPdf.addPage(page);
      });
    }

    const mergedPdfBytes = await mergedPdf.save();

    const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });

    const base64data = await new Promise((resolve) => {
      const reader = new FileReader();

      reader.readAsDataURL(blob);

      reader.onloadend = () => {
        resolve(reader.result.split(",")[1]);
      };
    });

    const reqOne = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      fileName: base64data,
      loan_id: loan_id,
      doc_type: "pdf",
      doc_name: "loan_agreement",
      status: "generated",
      id: latestLoanAgreement?.id,
    };

    await axios.post(url + "/loan/adddoc", reqOne);
    await uploadLoanDocHandler(stampPaper, "stamp_paper");

    if (revenueStamp) {
      await uploadLoanDocHandler(revenueStamp, "revenue_stamp");
    }
    setMergedBase64(base64data);
    setIsMerged(true);
  };

  function handlePreviewMergedDoc(){
    if (!mergedBase64) {
      return toast.error("No merged document available");
    }

    setPreviewType("merged");
    setNumPages(null);
    // setOpenManualModal(false);
    setOpenPreviewModal(true);
  };

  const handleEsign = async (docType) => {
    let text = `Are you sure you want to initiate esign for loan agreement?`;
    if (!window.confirm(text)) {
      return;
    }
    const { loan_id } = loanDetails;

    openLoader();

    const reqtBody = {
      loanId: loan_id,
      esignReason: docType,
      signPartner: "Digio",
    };
    if (loanDetails) {
      reqtBody[`mobile1`] = loanDetails?.mobile;
    }
    if (borrower) {
      reqtBody[`name1`] = borrower?.borrower_aadhaar_dump?.actions?.[0]?.details?.aadhaar?.name || borrower?.borrower_aadhaar_dump?.name ||
        borrower.borrower_firstname + " " + borrower.borrower_lastname;
      reqtBody[`signerType1`] = "aadhaar";
    }
    if (CoapplicantsArray && CoapplicantsArray.length > 0) {
      CoapplicantsArray.filter(
        (coapplcnt) => coapplcnt.coapplicant_loan_id === loan_id
      ).forEach((coapplcnt, i) => {
        let index = i + 2;
        reqtBody[`mobile${index}`] = coapplcnt.coapplicant_mobile;
        reqtBody[`name${index}`] = coapplcnt?.borrower_aadhaar_dump?.actions?.[0]?.details?.aadhaar?.name || coapplcnt?.borrower_aadhaar_dump?.name ||
          coapplcnt.coapplicant_name;
        reqtBody[`signerType${index}`] = "aadhaar";
      });
    }
    if (reqtBody.signerType1 === undefined) {
      toast.error("Borrower is required");
      return;
    }
    reqtBody.esignManual = openManualModal;
    try {
      const response = await axios.post(
        `${url}/loan/applicationform/esign`,
        reqtBody,
        {
          headers: {
            token: TOKEN,
            email: EMAIL,
          },
        }
      );
      if (response.data.auth) {
        closeLoader();
        toast.success(response?.data?.message);
        getSingleEsignDetails();
        setApplicantType({});
        setEsignModal(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      if (error?.response) {
        toast.error(error?.response?.data?.message);
        closeLoader();
        return;
      } else {
        toast.error("Something went wrong. Please try again later");
      }
    }
    let update_res = await axios.post(url + "/loan/updatestamp", {
      nbfc_name: foundLoan?.nbfc_name,
      loan_id: loan_id,
      Certificate_No: stamp_data?.Certificate_No,
      useBy: EMAIL,
      token: TOKEN,
      email: EMAIL,
    })
    console.log("update_res-> ", update_res)
    if (update_res?.data?.auth) {
      toast.success(update_res?.data?.message)
    }
    else {
      toast.error(update_res?.data?.data?.message)
    }

    closeLoader();
    setApplicantType({});
    setEsignModal(false);
  };

  const closePdfViewer = () => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: false,
      data: "",
    }));
  };

  const closeSingleDocModal = () => {
    setSingleDocModal((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  const getApplicationForm = async (docType) => {
    let text = `Are you sure you want to generate loan agreement?`;
    if (!window.confirm(text)) {
      return;
    }
    const { loan_id } = loanDetails;

    setLoanAgreementLoader(true);
    try {
      const response = await axios.post(
        `${url}/application/generatedynamicfield`,
        {
          loan_id: loan_id,
          doc_type: docType,
        },
        {
          headers: {
            token: TOKEN,
            email: EMAIL,
          },
        }
      );

      if (response.data.auth) {
        toast.success(response.data.message);
        const updateBorrower = await axios.post(
          url + "/borrower/borrowertoalldetails",
          {
            token: TOKEN,
            email: EMAIL,
            borrower_uniqueno: UNIQUE_NO,
          }
        );

        if (updateBorrower.data.auth) {
          const updatedLoan = updateBorrower.data.message.loan;
          const foundLoan = updatedLoan.find((item) => item.loan_id === loanid);

          updateBorrowerData((prevState) => ({
            ...prevState,
            loan: updatedLoan,
          }));

          setApplicationForms(foundLoan?.loan_agreement || []);
        }
      }
    } catch (error) {
      console.error("Error fetching Loan Agreement:", error);
      toast.error("Failed to fetch Loan Agreement. Please try again.");
    } finally {
      setLoanAgreementLoader(false);
    }
  };

  useEffect(() => {
    setApplicationForms(loanDetails?.loan_agreement || []);
  }, [loanDetails?.loan_agreement]);

  const esignInitiate = async () => {
    const { loan_id } = loanDetails;

    const esignReq = {
      token: TOKEN,
      email: EMAIL,
      borrower_uniqueno: UNIQUE_NO,
      loan_id: loan_id,
      loan_esign_by: esignVal,
    };
    const esignRes = await axios.post(url + "/loan/esign", esignReq);
    closeLoader();
    if (!esignRes?.data?.auth) {
      toast.error(esignRes?.data?.message);
      return;
    } else {
      toast.success(esignRes?.data?.message);
      setApplicantType({});
      setEsignModal(false);
      closeModal();
    }
  };

  //eslint-disable-next-line
  const uploadLoanDocHandler = (e, docName, id) => {
    const { loan_id } = loanDetails;

    openLoader();
    try {
      let address = e?.target?.files?.[0];
      if (!address) {
        closeLoader();
        return;
      }
      const docType = address?.name?.split(".").pop();
      if (docType !== "pdf" && docType !== "jpg" && docType !== "png") {
        closeLoader();
        toast.error("Please upload in PDF or Jpg or Png format only");
        return;
      }

      let reader = new FileReader();
      reader.readAsDataURL(address);
      reader.onload = async (eve) => {
        const base64data = eve.target.result.split(",").pop();
        const req = {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          borrower_uniqueno: localStorage.getItem("uniqueID"),
          fileName: base64data,
          loan_id: loan_id,
          doc_type: docType,
          doc_name: docName,
          id: id,
        };
        const res = await axios.post(url + "/loan/adddoc", req);
        if (!res.data.auth) {
          if (res.data.logout) {
            closeLoader();
            Navigate("/");
            return;
          }
          toast.error(res.data.message);
          closeLoader();
          return;
        }
        const updateBorrower = await axios.post(
          url + "/borrower/borrowertoalldetails",
          {
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
            borrower_uniqueno: localStorage.getItem("uniqueID"),
          }
        );
        if (!updateBorrower.data.auth) {
          closeLoader();
          return;
        }
        updateBorrowerData((prevState) => ({
          ...prevState,
          loan: updateBorrower.data.message.loan,
        }));

        toast.success(res.data.message);
        closeLoader();
        if (!["stamp_paper", "revenue_stamp"]?.includes(docName)) {
          closeModal();
        }
        return;
      };
    } catch (err) {
      toast.error("An error occoured");
      console.error(err);
      closeLoader();
      return;
    }
  };

  const groupedEsignData = useMemo(() => {
    if (!applicationForms?.length) return {};

    const sortedForms = [...applicationForms].sort((a, b) => {
      const dateA = new Date(a.timestamp || 0);
      const dateB = new Date(b.timestamp || 0);
      return dateB - dateA;
    });

    return sortedForms.reduce((acc, loan) => {
      const digioid = loan.did || loan.id;
      acc[digioid] = {
        digioid: loan.did || "",
        document_id: loan.id || null,
        timestamp: loan.timestamp || "-",
        esignInitiatedDate: loan.esignInitiatedDate || "-",
        signers:
          loan?.signing_parties?.length > 0
            ? loan.signing_parties
            : [
                {
                  name: loanDetails?.borrower_name || "-",
                  mobile: loanDetails?.mobile || "-",
                  status: loan.status || "-",
                  authentication_url: "",
                },
              ],
      };

      return acc;
    }, {});
  }, [loanDetails, applicationForms]);

  const viewStampPaper = () => {
    if (!stampBase64) {
      return toast.error("No stamp paper available to view");
    }

    try {
      const stampBytes = decodePdfBase64(stampBase64);

      let binary = "";
      const len = stampBytes.byteLength;

      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(stampBytes[i]);
      }

      const cleanBase64 = window.btoa(binary);

      // ONLY update stamp preview state
      setStampBase64(cleanBase64);
      setPreviewType("stamp");
      setNumPages(null);
      // setOpenPreviewModal(true);
      setmanualPDFmodal(true);
    } catch (err) {
      console.error("Error decoding stamp paper:", err);
      toast.error("Failed to load stamp paper. Invalid PDF data.");
    }
  };
  const uploadStampPaperHandlerCpanel = async () => {
    if (!stampPaper) {
      return toast.error("Please upload stamp paper");
    }

    const file = stampPaper.target.files[0];
    const revenuFile = revenueStamp?.target?.files?.[0];

    if (file.type !== "application/pdf") {
      return toast.error("Only PDF file is allowed");
    }

    if (revenuFile && revenuFile.type !== "application/pdf") {
      return toast.error("Only PDF file is allowed");
    }
    openLoader();

    const stampBase64 = await convertToBase64(stampPaper.target.files[0]);

    let revenueBase64 = null;
    if (revenuFile) {
      revenueBase64 = await convertToBase64(revenuFile);
    }

    const { loan_id } = loanDetails;
    const latestLoanAgreement = loanDetails?.loan_agreement?.at(-1);
    const req = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      doc_name: latestLoanAgreement.doc_name,
      doc_type: "pdf",
      loan_id: loan_id,
    };

    const res = await axios.post(url + "/loan/viewdoc", req);
    const loanAgreementBase64 = res.data?.doc_base64;

    const stampBytes = base64ToUint8Array(stampBase64);
    const agreementBytes = base64ToUint8Array(loanAgreementBase64);

    const stampPdf = await PDFDocument.load(stampBytes);
    const agreementPdf = await PDFDocument.load(agreementBytes);

    let revenuePdf = null;
    if (revenueBase64) {
      const revenueBytes = base64ToUint8Array(revenueBase64);
      revenuePdf = await PDFDocument.load(revenueBytes);
    }

    const mergedPdf = await PDFDocument.create();

    const stampPages = await mergedPdf.copyPages(
      stampPdf,
      stampPdf.getPageIndices()
    );

    stampPages.forEach((page) => {
      mergedPdf.addPage(page);
    });

    const agreementPages = await mergedPdf.copyPages(
      agreementPdf,
      agreementPdf.getPageIndices()
    );

    agreementPages.forEach((page) => {
      mergedPdf.addPage(page);
    });

    if (revenuePdf) {
      const revenuePages = await mergedPdf.copyPages(
        revenuePdf,
        revenuePdf.getPageIndices()
      );

      revenuePages.forEach((page) => {
        mergedPdf.addPage(page);
      });
    }

    const mergedPdfBytes = await mergedPdf.save();

    const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });

    const base64data = await new Promise((resolve) => {
      const reader = new FileReader();

      reader.readAsDataURL(blob);

      reader.onloadend = () => {
        resolve(reader.result.split(",")[1]);
      };
    });

    const reqOne = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      fileName: base64data,
      loan_id: loan_id,
      doc_type: "pdf",
      doc_name: "loan_agreement",
      status: "generated",
      id: latestLoanAgreement?.id,
    };

    await axios.post(url + "/loan/adddoc", reqOne);
    await uploadLoanDocHandler(stampPaper, "stamp_paper");

    if (revenueStamp) {
      await uploadLoanDocHandler(revenueStamp, "revenue_stamp");
    }
    setMergedBase64(base64data);
    setIsMerged(true);
  };
  useEffect(()=>{
   setIsMerged(false);
   setStampBase64("")
   setMergedBase64("")
   setRevenueStamp(null)
  },[esignVal])
  return (
    <>
      <div className={styles.topBar}>
        <h2>Esign Details</h2>
        <CloseIcon onClick={() => closeModal()} className={styles.CloseIcon} />
      </div>
      {pdfModal.open && (
        <PDFViewer url={pdfModal.data} closeModal={closePdfViewer} />
      )}
      {singleDocModal.open && (
        <SingleDocModal
          doc={singleDocModal.doc}
          docType={singleDocModal.docType}
          closeModal={closeSingleDocModal}
          isDownload={permissions?.download_loan_agreement}
          isDelete={permissions?.delete_loan_agreement}
        />
      )}
      {docModal && (
        <MultiDocsModal
          array={docs}
          closeModal={closeDocModal}
          title={name}
          isDownload={permissions?.download_loan_agreement}
          isDelete={permissions?.delete_loan_agreement}
        />
      )}
      <div className={styles.esignContent}>
        <div className={styles.esignActionWrapper}>
          <div>
            {loanDocsExist?.loanAgreement ? (
              <div className={styles.loanBtns}>
                {permission.generate_loan_agreement &&
                  (loanAgreementLoader ? (
                    <button disabled className={styles.DownloadLoanBtn}>
                      <CircularProgress size={12} color="inherit" />
                    </button>
                  ) : (
                    <button
                      className={styles.DownloadLoanBtn}
                      onClick={() => getApplicationForm("Loan Agreement")}
                    >
                      Regenerate
                    </button>
                  ))}
                {permission.initiate_loan_agreement && (
                  <button
                    className={styles.DownloadLoanBtn}
                    onClick={initiateEsignHandler}
                    style={{
                      whiteSpace: "nowrap",
                      width: "auto",
                    }}
                  >
                    Initiate Esign
                  </button>
                )}
                {permission.fetch_esign && (
                  <button
                    className={styles.DownloadLoanBtn}
                    onClick={() => getSingleEsignDetails()}
                  >
                    Fetch Details
                  </button>
                )}
                <Dialog
                  open={esignModal}
                  onClose={handleEsignModal}
                  PaperProps={{
                    component: "form",
                    onSubmit: (event) => {
                      event.preventDefault();
                      handleEsignClose();
                    },
                  }}
                >
                  <DialogContent>
                    <DialogContentText>
                      Do you want to initiate a E-Sign{" "}
                      <Checkbox onChange={handleChange} />
                    </DialogContentText>
                    {checked ? (
                      <div>
                        <div>
                          <label htmlFor="">
                            <>
                              {borrower.borrower_firstname}{" "}
                              {borrower.borrower_lastname}
                            </>
                          </label>
                          <TextField
                            size="small"
                            select
                            className={styles.modalSel}
                            variant="outlined"
                            onChange={(e) =>
                              applicantChangeHandler(e, "borrower")
                            }
                          >
                            <MenuItem value="aadhaar">aadhaar</MenuItem>
                            <MenuItem value="electronic">electronic</MenuItem>
                          </TextField>
                        </div>
                        <div>
                          <label>
                            Do you want to initiate a E-Sign for Co-Applicant
                          </label>{" "}
                          <Checkbox onChange={handleCoapplicantEsign} />
                        </div>
                        {coapplicantEsign ? (
                          <div>
                            {CoapplicantsArray.map((item, index) => (
                              <div key={index}>
                                <label htmlFor="">
                                  <>{item}</>
                                </label>
                                <TextField
                                  size="small"
                                  select
                                  className={styles.modalSel}
                                  variant="outlined"
                                  onChange={(e) =>
                                    applicantChangeHandler(e, item)
                                  }
                                >
                                  <MenuItem value="aadhaar">aadhaar</MenuItem>
                                  <MenuItem value="electronic">
                                    electronic
                                  </MenuItem>
                                </TextField>
                              </div>
                            ))}
                          </div>
                        ) : null}
                        <Button onClick={initiateEsignHandler}>Submit</Button>
                      </div>
                    ) : null}
                  </DialogContent>
                </Dialog>
              </div>
            ) : (
              <>
                {permission.generate_loan_agreement &&
                  (loanAgreementLoader ? (
                    <button disabled className={styles.DownloadLoanBtn}>
                      {" "}
                      <CircularProgress size={12} color="inherit" />
                    </button>
                  ) : (
                    <button
                      onClick={() => getApplicationForm("Loan Agreement")}
                      className={styles.DownloadLoanBtn}
                    >
                      Generate
                    </button>
                  ))}
              </>
            )}
          </div>
        </div>

        <div className={styles.tableContainer}>
          <div className={styles.tableDiv}>
            <table className={styles.customTable}>
              <thead>
                <tr>
                  <th>DOCUMENT ID</th>
                  <th>SIGNER NAME</th>
                  <th>STATUS</th>
                  <th>LINK</th>
                  {(permission?.upload_loan_agreement ||
                    permission?.view_loan_agreement) && (
                      <>
                        <th>DOCUMENT</th>
                        <th>AUDIT TRAIL</th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {Object.values(groupedEsignData).map((group) =>
                  group.signers.map((signer, index) => (
                    <tr key={`${group.digioid}-${index}`}>
                      {index === 0 && (
                        <td
                          rowSpan={group.signers.length}
                          className="font-medium"
                          style={{
                            maxWidth: "180px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <Tooltip title={group?.document_id} arrow>
                              <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  cursor: "pointer",
                                }}
                              >
                                {group?.document_id}
                              </span>
                            </Tooltip>
                            <Tooltip title={group?.digioid} arrow>
                              <span style={{ display: "flex" }}>
                                <AiOutlineEye
                                  cursor="pointer"
                                  size={20}
                                />
                              </span>
                            </Tooltip>
                          </div>
                        </td>
                      )}

                      <td>{signer.name}</td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <span
                            className={`px-2 py-1 text-xs rounded-full ${signer.status === "signed"
                              ? "bg-green-100 text-green-700"
                              : "bg-yellow-100 text-yellow-700"
                              }`}
                          >
                            {signer.status}
                          </span>
                        </div>
                      </td>

                      <td className="text-center">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          {signer.authentication_url ? (
                            <button
                              onClick={() => handleCopy(signer.authentication_url)}
                              className="text-blue-600 hover:text-blue-800"
                            >
                              {copied === signer.authentication_url ? (
                                <FaClipboardCheck cursor="pointer" size={18} />
                              ) : (
                                <FaClipboard cursor="pointer" size={18} />
                              )}
                            </button>
                          ) : (
                            <FaClipboard
                              className="text-gray-400"
                              cursor="pointer"
                              size={18}
                            />
                          )}
                        </div>
                      </td>
                      {index === 0 &&
                        (permission?.upload_loan_agreement ||
                          permission?.view_loan_agreement) && (
                          <td
                            rowSpan={group.signers.length}
                            className="text-center"
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              {permission?.view_loan_agreement && (
                                <AiOutlineEye
                                  cursor="pointer"
                                  size={20}
                                  onClick={() =>
                                    viewDocHandler(
                                      "loan_agreement",
                                      group?.document_id
                                    )
                                  }
                                />
                              )}

                              {permission?.upload_loan_agreement && (
                                <>
                                  <input
                                    type="file"
                                    className={styles.loanInputFile}
                                    id={`agreement-upload-${group?.document_id}`}
                                    onChange={(e) =>
                                      uploadLoanDocHandler(
                                        e,
                                        "loan_agreement",
                                        group?.document_id
                                      )
                                    }
                                  />

                                  <UploadFileOutlined
                                    cursor="pointer"
                                    size={16}
                                    onClick={() =>
                                      handleLoanAgreementUpload(
                                        group?.document_id
                                      )
                                    }
                                  />
                                </>
                              )}
                            </div>
                          <span
                            style={{
                              fontSize: "11px",
                              color: "#6b7280",
                            }}
                          > <strong> Initiated At:</strong> <nbsp />
                            {group?.esignInitiatedDate
                              ? new Date(group.esignInitiatedDate).toLocaleString()
                              : "-"}
                          </span>
                          <br />
                          <span
                            style={{
                              fontSize: "11px",
                              color: "#6b7280",
                            }}
                          > <strong>Updated At:</strong> <nbsp />
                            {group?.timestamp
                              ? new Date(group.timestamp).toLocaleString()
                              : "-"}
                          </span>
                        </td>
                        )}

                      {index === 0 &&
                        (permission?.upload_loan_agreement ||
                          permission?.view_loan_agreement) && (
                          <td
                            rowSpan={group.signers.length}
                            className="text-center"
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              {permission?.view_loan_agreement && (
                                <AiOutlineEye
                                  cursor="pointer"
                                  size={20}
                                  onClick={() =>
                                    viewDocHandler(
                                      "audit_trail",
                                      group?.document_id
                                    )
                                  }
                                />
                              )}

                              {permission?.upload_loan_agreement && (
                                <>
                                  <input
                                    type="file"
                                    className={styles.loanInputFile}
                                    id={`audit-upload-${group?.document_id}`}
                                    onChange={(e) =>
                                      uploadLoanDocHandler(
                                        e,
                                        "audit_trail",
                                        group?.document_id
                                      )
                                    }
                                  />

                                  <UploadFileOutlined
                                    cursor="pointer"
                                    size={16}
                                    onClick={() =>
                                      handleAuditUpload(group?.document_id)
                                    }
                                  />
                                </>
                              )}
                            </div>
                          </td>
                        )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Dialog
          open={esignModal}
          onClose={handleEsignClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              handleEsignClose();
            },
          }}
        >
          <DialogContent>
            <DialogContentText>
              Do you want to initiate a E-Sign{" "}
              <Checkbox onChange={handleChange} />
            </DialogContentText>
            {checked ? (
              <div>
                <div>
                  <label htmlFor="">
                    <>
                      {borrower.borrower_firstname} {borrower.borrower_lastname}
                    </>
                  </label>
                  <TextField
                    size="small"
                    select
                    className={styles.modalSel}
                    variant="outlined"
                    onChange={(e) => applicantChangeHandler(e, "borrower")}
                  >
                    <MenuItem value="aadhaar">aadhaar</MenuItem>
                    <MenuItem value="electronic">electronic</MenuItem>
                  </TextField>
                </div>
                <div>
                  <label>
                    Do you want to initiate a E-Sign for Co-Applicant
                  </label>{" "}
                  <Checkbox onChange={handleCoapplicantEsign} />
                </div>
                {coapplicantEsign ? (
                  <div>
                    {CoapplicantsArray.map((item, index) => (
                      <div key={index}>
                        <label htmlFor="">
                          <>{item}</>
                        </label>
                        <TextField
                          size="small"
                          select
                          className={styles.modalSel}
                          variant="outlined"
                          onChange={(e) => applicantChangeHandler(e, item)}
                        >
                          <MenuItem value="aadhaar">aadhaar</MenuItem>
                          <MenuItem value="electronic">electronic</MenuItem>
                        </TextField>
                      </div>
                    ))}
                  </div>
                ) : null}
                <Button onClick={esignInitiate}>Submit</Button>
              </div>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>

      {openEsignOptionModal && (
        <div className="modal">
          <div className="modal-content">
            <label style={{ fontSize: "12px" }}>Select Esign Option</label>

            <br />

            <TextField
              size="small"
              select
              required
              value={esignVal}
              variant="outlined"
              onChange={(e) => setEsignVal(e.target.value)}
              style={{ marginBottom: 15, width: "22rem" }}
            >
              <MenuItem value="api">API</MenuItem>
              <MenuItem value="manual">Manual</MenuItem>
              <MenuItem value="manual_cpanel">Manual Cpanel</MenuItem>
            </TextField>

            <br />

            <button
              className={styles.DownloadLoanBtn}
              onClick={() => handleEsignOption(esignVal)}
            >
              Initiate Esign
            </button>

            <button
              className={styles.DownloadLoanBtn}
              style={{ marginLeft: 10 }}
              onClick={() => setOpenEsignOptionModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
      {openCpanelModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Selected Stamp Paper</h3>
            <br />
            {/* <input type="file" onChange={handleStampPaperChange} /> */}
            <h5>{stamp_data?.Certificate_No ||(StampDocLoading ? "Loading..." : "stamp not found !")}</h5>
            <button
              className={styles.DownloadLoanBtn}
              onClick={viewStampPaper}>
              view stamp
            </button>
            <br />
            <br />
            <h5>Remaining stamps:{stampInfo}</h5>
            <br />

            <h3>Upload Revenue Stamp (If Applicable)</h3>
            <br />
            <input type="file" onChange={handleRevenueStampChange} />
            <br />
            <br />
            <br />

            {/* Merge Button */}
            <button
              className={styles.DownloadLoanBtn}
              onClick={uploadStampPaperHandler}
              disabled={!stampBase64}
            >
              Merge
            </button>

            {/* Preview Button */}
            <button
              className={styles.DownloadLoanBtn}
              onClick={handlePreviewMergedDoc}
              disabled={!isMerged}
            >
              Preview
            </button>

            {/* Initiate Esign Button: Only enabled after a successful merge */}
            <button
              className={styles.DownloadLoanBtn}
              onClick={() => handleEsign("Loan Agreement")}
              disabled={!isMerged}
            >
              Initiate Esign
            </button>

            <button
              className={styles.DownloadLoanBtn}
              onClick={() => setopenCpanelModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
      {openPreviewModal && (
        <div className="modal">
          <div
            style={{
              width: "80%",
              maxWidth: "800px",
              overflow: "auto",
              maxHeight: "600px",
              position: "absolute",
              top: "52%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "#ffffff",
              padding: "2rem",
              borderRadius: "3px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <h3>Merged Document Preview</h3>
              <CloseIcon
                onClick={() => setOpenPreviewModal(false)}
                className={styles.CloseIcon}
                style={{ cursor: "pointer" }}
              />
            </div>
            {pdfFile ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Document
                  file={pdfFile}
                  onLoadSuccess={onDocumentLoadSuccess}
                  onPassword={handlePassword}
                  loading={<p>Loading PDF...</p>}
                  error={<p>Failed to load PDF document.</p>}
                >
                  {Array.from(
                    new Array(numPages || 0),
                    (_, index) => index + 1
                  ).map((pageNum) => (
                    <Page
                      key={pageNum}
                      pageNumber={pageNum}
                      className={pdfStyles?.pdfStyle}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                      width={width}
                    />
                  ))}
                </Document>
              </div>
            ) : (
              <p>No document available for preview.</p>
            )}
            <div style={{ marginTop: "15px", textAlign: "right" }}>
              <button
                className={styles.DownloadLoanBtn}
                onClick={() => setOpenPreviewModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {openManualModal && (<div className="modal">
        <div className="modal-content">
          <h3>Upload Stamp Paper</h3>
          <br />
          <input type="file" onChange={handleStampPaperChange} />

          <br />
          <br />
          <br />
          <h3>Upload Revenue Stamp (If Applicable)</h3>
          <br />
          <input type="file" onChange={handleRevenueStampChange} />
          <br />
          <br />
          <br />

          {/* Merge Button */}
          <button
            className={styles.DownloadLoanBtn}
            onClick={uploadStampPaperHandlerCpanel}
            disabled={!stampPaper}
          >
            Merge
          </button>
          {/* Preview Button */}
          <button
            className={styles.DownloadLoanBtn}
            onClick={() => {
              setPreviewType("merged");
              setmanualPDFmodal(true);
            }}
            disabled={!isMerged}
          >
            Preview
          </button>

          {/* Initiate Esign Button: Only enabled after a successful merge */}
          <button
            className={styles.DownloadLoanBtn}
            onClick={() => handleEsign("Loan Agreement")}
            disabled={!isMerged}
          >
            Initiate Esign
          </button>

          <button
            className={styles.DownloadLoanBtn}
            onClick={() => setOpenManualModal(false)}
          >
            Close
          </button>
        </div>
      </div>)}
      <Modal
        open={manualPDFmodal}
        onClose={() => setmanualPDFmodal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modal">
          <div
            style={{
              width: "80%",
              maxWidth: "800px",
              overflow: "auto",
              maxHeight: "600px",
              position: "absolute",
              top: "52%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "#ffffff",
              padding: "2rem",
              borderRadius: "3px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <h3>Document Preview</h3>
              <CloseIcon
                onClick={() => setmanualPDFmodal(false)}
                className={styles.CloseIcon}
                style={{ cursor: "pointer" }}
              />
            </div>
            {pdfFile ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Document
                  file={pdfFile}
                  onLoadSuccess={onDocumentLoadSuccess}
                  onPassword={handlePassword}
                  loading={<p>Loading PDF...</p>}
                  error={<p>Failed to load PDF document.</p>}
                >
                  {Array.from(
                    new Array(numPages || 0),
                    (_, index) => index + 1
                  ).map((pageNum) => (
                    <Page
                      key={pageNum}
                      pageNumber={pageNum}
                      className={pdfStyles?.pdfStyle}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                      width={width}
                    />
                  ))}
                </Document>
              </div>
            ) : (
              <p>No document available for preview.</p>
            )}
            <div style={{ marginTop: "15px", textAlign: "right" }}>
              <button
                className={styles.DownloadLoanBtn}
                onClick={() => setmanualPDFmodal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EsignModal;